import { render, staticRenderFns } from "./AssistantAsks.vue?vue&type=template&id=45addac6&"
import script from "./AssistantAsks.vue?vue&type=script&lang=js&"
export * from "./AssistantAsks.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports